import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { Member, MemberService } from 'src/app/apis/member.service';
import { FormBuilder, FormGroup } from '@ngneat/reactive-forms';
import { PageModel } from 'src/app/utils/interfaces/page-model';
import {
  ItemWinLoseDetail,
  PaginationWinlose,
  ReportWinloseService,
} from 'src/app/apis/report-winlose.service';
import { formPage } from 'src/app/utils/functions/form-page';
import { AppCore } from 'src/app/utils/classes/app-core';
import { alertConfirm, alertSuccess, alertText } from 'src/app/utils/functions/alert';
import { Pagination } from 'src/app/utils/interfaces/pagination';
import { FixTransactionBetService } from 'src/app/apis/fix-transaction-bet.service';

@Component({
  selector: 'app-winlose-detail',
  templateUrl: './winlose-detail.component.html',
  styleUrls: ['./winlose-detail.component.scss'],
})
export class WinloseDetailComponent extends AppCore implements OnInit, OnChanges, OnDestroy {
  form = formPage({
    from: '',
    to: '',
    agent_id: '',
    member_id: '',
    game_type: '',
    game_code: '',
    username: '',
  });
  showPercentAdmin = false;

  userSameDetail = ['casino'];
  userSameSlotDetail = ['slot', 'game_card', 'cockfight', 'keno', 'lotto_game'];
  userSameSportDetail = 'sports';

  winloseItems: Pagination<any[]> | undefined;
  loadingWinlose = false;

  ActiveSportDetail: any;
  ActiveESportDetail: any;
  ActiveLottoDetail: any;

  BetIdActive: string;
  GameTypeActive: string;

  currentPage = 1;

  constructor(
    private svReportWinLose: ReportWinloseService,
    private svFix: FixTransactionBetService
  ) {
    super();
    this.Subscriptions.add(
      this.svReportWinLose.$onSubmit.subscribe((res: any) => {
        if (res) {
          this.form.patchValue({
            ...res,
          });
          setTimeout(() => {
            this.form.get('limit').setValue(500);
            this.getMemberWinloseDetail();
            this.onBack();
          }, 200);
        }
      })
    );
    this.Subscriptions.add(
      this.svReportWinLose.$onBackFromDetail.subscribe(() => {
        this.onBack();
      })
    );
  }

  ngOnInit(): void {}
  ngOnChanges(): void {}
  currentAgentChanged(): void {}
  ngOnDestroy(): void {
    this.Subscriptions.unsubscribe();
  }
  onBack() {
    this.BetIdActive = '';
    this.GameTypeActive = '';
  }
  getMemberWinloseDetail() {
    this.loadingWinlose = true;
    this.svReportWinLose
      .getWinloseDetail(this.form.value)
      .pipe(finalize(() => (this.loadingWinlose = false)))
      .subscribe((res) => {
        this.winloseItems = res;
      });
  }
  pageChanged(event: any) {
    this.form.get('page').setValue(event.page);
    this.form.get('limit').setValue(event.limit);
    this.currentPage = event.page;
    this.getMemberWinloseDetail();
  }

  openPrint(item: any) {
    this.ActiveSportDetail = item;
  }
  openPrintEsports(item: any) {
    this.ActiveESportDetail = item;
  }
  openPrintLotto(item: any) {
    this.ActiveLottoDetail = item;
  }
  saveWinloseDetail(betId: string) {
    this.svReportWinLose.saveWinloseDetailSport(betId).subscribe(() => {
      this.getMemberWinloseDetail();
    });
  }

  async requestUpdateWinLoseDetail(item: any) {
    const swal = await alertConfirm({ html: `ยืนยัน การแก้ไข W/L?` });
    if (!swal.isConfirmed) {
      return;
    }

    this.svReportWinLose.requestWinLose(item.betId).subscribe((res) => {
      alertSuccess({ message: alertText.saveSuccess });
      this.getMemberWinloseDetail();
    });
  }

  async sendCallback(item: any) {
    const swal = await alertConfirm({ html: `sendcallback BETID : ${item.betId}` });
    if (!swal.isConfirmed) {
      return;
    }

    this.svReportWinLose.sendCallback(item.betId).subscribe((res) => {
      alertSuccess({ message: `success send callback` });
    });
  }

  onSetActiveDetail(betId: string, gameType: string) {
    console.log(betId, gameType);
    this.BetIdActive = betId;
    this.GameTypeActive = gameType;
  }
  fixMakeBetCancel(data: any) {
    alertConfirm({ html: `คุณต้องการยกเลิก BET ID : <b>${data.betId}</b> หรือไม่?` }).then((c) => {
      if (c.isConfirmed) {
        this.svFix
          .makeCannelBet({
            game_type: data.gameType,
            username: data.member,
            betId: data.betId,
            txnId: "",
            roundId: "",
          })
          .subscribe(() => {
            alertSuccess({ message: 'cancel bet success ' + data.txnId });
            this.getMemberWinloseDetail();
          });
      }
    });
  }
}
